<template>
  <div class="video-player">
    <!-- ref 通过此引用去调用dhplayer内部的方法API -->
    <!-- videoId 唯一标识 -->
    <!-- windowType 0-实时预览，3-录像回放，7-录像回放(支持倒放) -->
    <!-- coverShieldClass 处理DOM元素遮挡问题，主要用于滚动页面，超出隐藏的问题 -->
    <!-- shieldClass 处理DOM元素遮挡问题 -->
    <dh-player ref="dhPlayerRealTime" videoId="dhPlayerRealTime"
      :shieldClass="['el-message', 'el-message-box', 'el-dialog', 'el-picker-panel', 'hover-blur-panel']"
      :windowType="windowType" :division="division" @createSuccess="createSuccess" @createError="createError"
      @realSuccess="realSuccess" @realError="realError" @clickWindow="clickWindow" :request="ajaxRequest" @picCap="picCap"
      @videoDownloadSuccess="videoDownloadSuccess" @dhPlayerMessage="dhPlayerMessage"></dh-player>
  </div>
</template>

<script>
import DhPlayer from "@/components/business/dh-player/index.vue"
import busVue from "@/common/utils/busVue";
import { api } from "../api.js";
export default {
  components: {
    DhPlayer
  },
  computed: {
    ajaxRequest() {
      return {
        setPtzDirection: this.setPtzDirection, // 云台方向控制接口 （云台使用）
        setPtzCamera: this.setPtzCamera // 云台镜头控制接口 （云台使用）
      }
    }
  },
  data() {
    return {
      // 播放类型
      windowType: 0,
      // 分割窗格
      division: 4,
      // 当前窗口
      currentNum: 0,
      // 最大只支持64路播放
      maxWin: 64,
      // 错误消息
      playerErrMessage: null,
      firstIp: ''
    };
  },
  created() {
    let hostName = location.hostname;
    let ipIndex = hostName.indexOf('.')
    if (ipIndex !== -1) {
      this.firstIp = hostName.substring(0, ipIndex)
    }
    busVue.$on("dhHandleChooseCamera", (info, isBatch = false) => {
      this.dhHandleChooseCamera(info, isBatch);
    });
  },
  beforeDestroy() {
    busVue.$off("dhHandleChooseCamera");
    this.$refs.dhPlayerRealTime.closeVideo()
    this.$refs.dhPlayerRealTime.destroy()
  },
  methods: {
    dhPlayerMessage(info, err) {
      console.log(info, err)
    },
    // 创建成功回调
    createSuccess() {
      this.$refs.dhPlayerRealTime.initPanTilt('dhplayer-pan-tilt')
    },
    // 插件创建失败回调
    createError(err) {
      this.playerErrMessage = err
    },
    // 抓图回调
    picCap(item) {
      // console.log(item)
      let time = new Date().getTime()
      var img = "data:image/png;base64," + item.base64Url
      var link = document.createElement('a');
      link.href = img;
      link.download = `抓拍图片${time}.png`;
      link.click();
    },
    videoDownloadSuccess(recordUrl) {
      this.$message.success("本地录像下载完成，地址为：" + recordUrl)
    },
    // 双击摄像机播放实时视频
    dhHandleChooseCamera(info, isBatch) {
      if (this.playerErrMessage && this.playerErrMessage.code === 1001) {
        this.$message({
          message: this.playerErrMessage.message,
          type: 'warning'
        });
        return
      }
      if (isBatch) {
        this.handleBatchPlay(info);
        return;
      }
      // 通过通道ID播放实时预览
      this.queryVideoRtsp(info);
    },
    // 批量播放实时视频
    handleBatchPlay(infos) {
      if (infos.length > this.maxWin) {
        this.$message({
          message: "当前最多支持播放" + this.maxWin + "路视频",
          type: 'warning'
        });
      }
      this.division = infos.length
      let playArr = [...infos].splice(0, this.maxWin + 1);
      playArr.forEach((item) => {
        setTimeout(() => {
          this.queryVideoRtsp(item);
        });
      });
    },
    // 获取直播url并播放
    queryVideoRtsp(option) {
      const param = {
        deviceIdList: [option.thirdCameraId],
        protocol: 'rtsp'
      }
      let cameraDetail = {}
      if (option.thirdDeviceDesc) {
        cameraDetail = JSON.parse(option.thirdDeviceDesc)
      }
      this.$fetch(api.queryRealTimeVideoRtsp, param).then(res => {
        if (res.success) {
          let inNetUrl = res.returnObj[0].url.substring(0, res.returnObj[0].url.indexOf('|'))
          let outNetUrl = res.returnObj[0].url.substr(res.returnObj[0].url.indexOf('|') + 1, res.returnObj[0].url.length)
          // console.log('内网', inNetUrl)
          // console.log('外网', outNetUrl)
          let rtspUrl = ''
          if (this.firstIp == '10' || this.firstIp == '172' || this.firstIp == '192') {
            rtspUrl = inNetUrl
          } else {
            rtspUrl = outNetUrl
          }
          let rtspObj = {
            channelId: res.returnObj[0].deviceId,
            path: rtspUrl,
            cameraType: cameraDetail.cameraType,
            capability: cameraDetail.capability
          }
          console.log(rtspObj, '@@##$$')
          this.realByUrl(rtspObj)
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    // 通过通道ID播放实时预览
    realByChannel(deviceInfo) {
      let param = [{
        channelId: deviceInfo.id,  // 通道ID,必传
        snum: this.currentNum,  // 即将要播放的窗口序号,从0开始,必传
        cameraType: deviceInfo.cameraType,  // 摄像头类型(用于云台)
        capability: deviceInfo.capability,  // 能力集(用于云台)
        deviceType: deviceInfo.deviceType,  // 设备类型(用于对讲)
        streamType: 0,  // 1-主码流  2-辅码流 (可不传，默认主码流)
      }]
      this.$refs.dhPlayerRealTime.startReal(param)
      this.currentNum = this.currentNum + 1
    },
    // 通过rtsp流播放实时预览
    realByUrl(deviceInfo) {
      let param = {
        channelId: deviceInfo.channelId,  // 通道ID,必传
        path: deviceInfo.path,  // 流地址 
        redirect: false, // 9090端口为true   9100端口为false 必传
        cameraType: deviceInfo.cameraType,
        capability: deviceInfo.capability
      }
      // console.log(param, '播放参数')
      this.$refs.dhPlayerRealTime.realByUrl(param, this.currentNum) // 播放的窗口序号 (从0开始计数，表示第一个窗口)
      this.currentNum = this.currentNum + 1
    },
    // 播放成功
    realSuccess(info, second, third) {
      // console.log("实时预览成功", info)
    },
    // 播放失败
    realError(info, err) { // 放回通道信息和错误提示
      this.$message({
        message: err.message,
        type: 'warning'
      });
      if (this.currentNum > 0) {
        this.currentNum = this.currentNum - 1
      }
      // console.log('当前窗口数', this.currentNum)
    },
    // 点击的窗口
    clickWindow(snum, item) {
      this.currentNum = snum
      // console.log("当前点击窗口信息", item)
    },
    /**
     * 云台方向控制
     * @param param
     * @returns {Promise<unknown>}
     */
    async setPtzDirection(param) {
      await this.$fetch('icc/admin/operate-direct', param).then(res => {
        if (res.code == '1000' || res.code == '521') {
          // console.log("调用成功")
        } else {
          // this.$message.error(res.desc)
        }
      })
    },
    /**
     * 云台镜头控制
     * @param param
     * @returns {Promise<unknown>}
     */
     async setPtzCamera(param) {
      await this.$fetch('icc/admin/operate-camera', param).then(res => {
        if (res.code == '1000' || res.code == '521') {
          // console.log("调用成功")
        } else {
          // this.$message.error(res.desc)
        }
      })
    },
    // 触发抓图，如果用插件自带的抓图，无需此方法。
    snapshot() {
      this.$refs.dhPlayerRealTime.snapshot(this.currentNum) // 传入播放的窗口序号（从0开始）
    },
  }
}
</script>

<style lang="scss" scoped>
.video-player {
  width: 100%;
  height: 100%;
}
</style>